import { render, staticRenderFns } from "./MraCompensacaoTable.vue?vue&type=template&id=6addd097&scoped=true&lang=pug"
import script from "./MraCompensacaoTable.vue?vue&type=script&lang=js"
export * from "./MraCompensacaoTable.vue?vue&type=script&lang=js"
import style0 from "./MraCompensacaoTable.vue?vue&type=style&index=0&id=6addd097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6addd097",
  null
  
)

export default component.exports